export const environment = {
  name: 'test',
  localInstance: false,
  production: true,
  backendUrl: "__API_URL__",
  collaboratorBasePath: '/collaborators',
  themesAndAssetsUrl: 'https://ajilach.github.io/angular-material-themes/public/'
};
